/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import styled from "styled-components";

const StatLabel = styled.span`
  font-weight: 900;
`;

export const DebugPanelStat: React.FC<{
  label: string;
  value?: string | number;
}> = ({ label, value }) => {
  return (
    <div>
      <StatLabel>{label}:</StatLabel> {value}
    </div>
  );
};
